import { Box, Typography } from '@mui/material';

import { SpinnerIcon } from '../SpinnerIcon/SpinnerIcon';

export interface LoadingSpinnerProps {
  /**
   * @prop {string} - id of the spinner icon component
   */
  id: string;

  /**
   * @prop {string} - title of the error message
   */
  title?: string;
}

export function LoadingSpinner(props: LoadingSpinnerProps) {
  const { id, title } = props;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%"
      data-testid={`${id}-loading`}
    >
      <SpinnerIcon id={`${id}-loadingSpinner`} data-testid={`${id}-loadingSpinner`} />
      {title && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          mt={2}
        >
          <Typography
            data-testid={`${id}-loadingSpinnerTitle`}
            variant="h6"
            component="span"
            color="textPrimary"
            textAlign="center"
          >
            {title}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
